// extracted by mini-css-extract-plugin
export default {"box":"BlogSec_box__czZD7","contentCol":"BlogSec_contentCol__fBGHf","foot":"BlogSec_foot__34-35","readMore":"BlogSec_readMore__dn5mC"};